module.exports = __webpack_public_path__ + "img/qrcode1.20e35a24.png";